/**
 * True once a preview has been requested at least once and the audience filters have since
 * changed, invalidating it (`shouldFetch` is reset to `false` on any filter change — see the
 * Sabil/Mutawatteen outstanding panels' `selectionKey` effect and `invalidatePreview`).
 */
export function shouldShowStalePreviewBanner(
  hasPreviewedOnce: boolean,
  shouldFetch: boolean
): boolean {
  return hasPreviewedOnce && !shouldFetch;
}

/**
 * True when the preview fetch (capped at `OUTSTANDING_PREVIEW_FETCH_LIMIT`) didn't cover every
 * qualifying recipient — the server-reported `fullTotal` exceeds what was actually fetched.
 */
export function isPreviewTruncated(fetchedRowCount: number, fullTotal: number): boolean {
  return fetchedRowCount < fullTotal;
}

/**
 * "Will be sent" count for the summary banner — the server-reported true total (not the possibly
 * truncated `rows.length`, so the count stays correct even when the preview fetch is capped)
 * minus rows the admin unchecked in the preview table.
 */
export function computeVisibleSendTotal(fullTotal: number, excludedCount: number): number {
  return Math.max(0, fullTotal - excludedCount);
}
